var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"lc-export-button",attrs:{"loading":_vm.loading,"disabled":_vm.recordsCount === 0 || _vm.disabled,"type":"primary","icon":"el-icon-download"},on:{"click":_vm.handleExportReport}},[_vm._v(_vm._s(_vm.btnText)),(_vm.seconds)?_c('span',[_vm._v(" "+_vm._s(_vm.seconds)+"s")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }